import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import { AxiosResponse } from 'axios';
import {
  CreateTagDto,
  Tag,
  TagListResponse,
  UpdateTagDto,
} from './TagControl.type';

let listRequest: any = null;

const REQUEST_PREFIX = 'tag';

export const tagControlService = {
  getList: (params: {
    q?: string;
    page?: number | string;
    sort?: string;
  }): Promise<AxiosResponse<TagListResponse>> => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();

    return axios.get(getEndpointBase(`${REQUEST_PREFIX}/list`), {
      cancelToken: listRequest.token,
      params,
    });
  },

  create: (data: CreateTagDto): Promise<AxiosResponse<Tag>> => {
    return axios.post(getEndpointBase(`${REQUEST_PREFIX}/create`), data);
  },

  update: (data: UpdateTagDto): Promise<AxiosResponse<Tag>> => {
    return axios.put(getEndpointBase(`${REQUEST_PREFIX}/${data.id}`), data);
  },

  delete: (id: number): Promise<AxiosResponse> => {
    return axios.delete(getEndpointBase(`${REQUEST_PREFIX}/${id}`));
  },
};
